@if (!modal) {
  <ds-breadcrumb [breadcrumbs]="breadcrumbs$ | async"></ds-breadcrumb>
}

<div class="row">
  <div class="col-md-12">
    <div class="col-12" [ngClass]="{ card: !modal }">
      @if (!modal) {
        <div class="card-header">
          <h1>
            {{ 'edit_digital_property' | translate }}
          </h1>
        </div>
      }

      <div class="card-body" [ngClass]="{ 'p-0': modal }">
        <app-edit-tenant-workspace-digital-property-form
          [modal]="modal"
          [digitalPropertyData]="digitalProperty"
          [isWebsite]="isWebsite"
          (digitalPropertyAction$)="digitalPropertyAction$($event)"
          (cancelled)="onCancel()"
        ></app-edit-tenant-workspace-digital-property-form>
      </div>
    </div>
  </div>
</div>
